import { render, staticRenderFns } from "./DialogGenerarSpent.vue?vue&type=template&id=2e267774&"
import script from "./DialogGenerarSpent.vue?vue&type=script&lang=js&"
export * from "./DialogGenerarSpent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports